<template>
	<div style="position: relative;">
		<div  style="background:#013a8a;width: 200px; height: 60px;display: flex;">
			<div class="tou_wen"><i class="el-icon-s-platform"></i>管理系统</div>
			<i class="el-icon-s-unfold" @click="collapseStatus"></i>
		</div>
		<el-scrollbar class="zuocaidan">
			<el-menu default-active="6" style="border-right:0;" text-color="#c6c7c7" active-text-color="#FFFFFF"
			 router :unique-opened="true" class="elmenu" :collapse="isCollapse">				 
				<el-submenu index="6">
					<template slot="title"> <i class="el-icon-set-up"></i><span slot="title">核销</span></template>

					<el-menu-item index="hexiao">核销</el-menu-item>			
					<el-menu-item index="hexiaomingxi">核销明细</el-menu-item>	
				    <el-menu-item index="hexiaomingxiall">核销总明细</el-menu-item>
				</el-submenu>
			<el-submenu index="9">
				<template slot="title"> <i class="el-icon-shopping-bag-1"></i><span slot="title">门店商城消费明细</span></template>
				<el-menu-item index="yue">卡消费明细</el-menu-item>
				<el-menu-item index="weixinmingxi">微信消费明细</el-menu-item>
			</el-submenu>
			<el-submenu index="8">
				<template slot="title"> <i class="el-icon-shopping-bag-1"></i><span slot="title">产品服务</span></template>
				<el-menu-item index="mendian_xiangqing">门店详情</el-menu-item>
				<el-menu-item index="shangpin_mendian">商品管理</el-menu-item>
				<el-menu-item index="dingdan_zitimendian">预定产品订单</el-menu-item>
				<el-menu-item index="dingdan_mendian">门店配送订单</el-menu-item>
			</el-submenu>	
			
			</el-menu>
		</el-scrollbar>
	</div>
</template>

<script>
	export default {
		name: 'zuo',
		props: {
			msg: String
		},
		data() {
			return {
				isCollapse: false
			};
		},
		methods: {
			collapseStatus() {
				this.collapseBtnClick = this.isCollapse;
				this.isCollapse = !this.isCollapse;
				if(this.isCollapse){
					this.$emit('click','100px');
				}else{
					this.$emit('click','200px');
				}
				
			},
			collapseOpen() {
				if (this.collapseBtnClick) return;
				this.isCollapse = false;
			},

			collapseClose() {
				if (this.collapseBtnClick) return;
				this.isCollapse = true;
			}
		}
	}
</script>


<style>
    
	.zuocaidan .el-scrollbar__wrap {
		overflow-x: hidden;
		max-height: 100vh;		
	}
	.zuocaidan .el-scrollbar__view{
		margin-bottom: 100px;
	}
	.elmenu:not(.el-menu--collapse) {
		background: #041526;
	}

	.elmenu .el-submenu__title:hover {
		background: #022D5C;
	}

	.el-submenu .el-menu-item {
		background-color: #000a13 !important;
	}

	.el-submenu .el-menu-item:hover,
	.el-submenu .is-active {
		background-color: #022D5C !important;
	}
	.el-menu{
		background: none;
	}
	.el-icon-s-platform{margin-right: 10px;color: #FFFFFF;}
	.tou_wen{font-size: 24px;margin-top: 10px;color: #FFFFFF;margin-left: 8px;width: 69%;}
	.el-icon-s-unfold{margin-left: 8px;background:#013a8a;border: none;color: #FFFFFF;font-size:18px;position: absolute;top: 18px; right: 26px;}
	.elmenu{
		width: 100%;
	}
</style>
